import React from 'react';
import Calendar from 'react-calendar';
import { InputGroup, Form, Modal } from 'react-bootstrap';
import IconButton from './IconButton';
import { faCalendarAlt } from '@fortawesome/free-regular-svg-icons';
import styled from 'styled-components';
import * as moment from 'moment';
import { showError } from '../components/Messages';
import { replaceAll } from '../utils/Functions';
import '../contents/css/date-input.css';

export default class DateInput extends React.Component {
   constructor(props) {
      super(props);

      let date = new Date();
      if (props.defaultValue && moment(props.defaultValue).isValid()) {
         date = moment(props.defaultValue).toDate();
      }

      this.state = { date: date, dataDigitada: moment(date).format('DD/MM/YYYY'), mostrarCalendario: false };
      this.setDateFromCalendar = this.setDateFromCalendar.bind(this);
   }

   setDateFromCalendar(value) {
      let date = value;
      this.setState({ date: date });
      if (!date) {
         if (this.input) {
            this.input.value = null;
         }
         this.setState({ dataDigitada: null });
      } else {
         if (this.input) {
            this.input.value = moment(date).format('DD/MM/YYYY');
         }
         this.setState({ dataDigitada: moment(date).format('DD/MM/YYYY') });
      }
      if (this.props.onChange) {
         this.props.onChange(date);
      }
   }

   closeCalendar() {
      setTimeout(() => {
         this.setState({ mostrarCalendario: false });
      }, 100);
   }

   render() {
      let inputBackgroundColor = {
         backgroundColor: this.props.readOnly ? '#e9ecef' : null,
         paddingLeft: 6,
         paddingRight: 6,
      };
      return (
         <DateInputStyled style={{ display: 'flex' }} name={this.props.name} id={this.props.id} key={this.props.key}>
            <InputGroup style={{ backgroundColor: 'transparent', flexWrap: 'nowrap' }}>
               <Form.Control
                  type='text'
                  className={'date-input' + (this.props.className ? ' ' + this.props.className : '')}
                  ref={(c) => (this.input = c)}
                  defaultValue={this.props.defaultValue ? moment(this.state.date).format('DD/MM/YYYY') : null}
                  style={{ ...this.props.style, ...inputBackgroundColor }}
                  onChange={(e) => {
                     this.setState({ dataDigitada: e.target.value });
                  }}
                  readOnly={this.props.readOnly}
                  maxLength={10}
                  onBlur={() => {
                     if (this.state.dataDigitada) {
                        var dataString = replaceAll(this.state.dataDigitada, '/', '');
                        var dia = dataString.substr(0, 2);
                        var mes = dataString.substr(2, 2);
                        var ano = dataString.substr(4, 4);
                        var d = new Date(parseInt(ano), parseInt(mes) - 1, parseInt(dia));
                        var d2 = moment(d);
                        if (d2.isValid() && dataString === d2.format('DDMMYYYY')) {
                           /*this.setState({ date: d2.toDate(), mostrarCalendario: false }, () =>
                              this.setState({ mostrarCalendario: true })
                           );*/
                           if (this.props.onChange) {
                              this.props.onChange(d2.toDate());
                           }
                           this.input.value = d2.format('DD/MM/YYYY');
                        } else {
                           showError(this.state.dataDigitada + ' não é uma data válida.');
                           this.input.value = moment(this.state.date ? this.state.date : new Date()).format(
                              'DD/MM/YYYY'
                           );
                        }
                     } else {
                        this.setState({ date: null, dataDigitada: null });
                        if (this.props.onChange) {
                           this.props.onChange(null);
                        }
                     }
                  }}
               />
               {!this.props.readOnly && (
                  <InputGroup.Append
                     className='hide-when-readonly'
                  >
                     <InputGroup.Text
                        style={{
                           padding: '1px 6px 1px 6px',
                           height: this.props.style && this.props.style.height ? this.props.style.height : 38,
                           width: 40,
                           justifyContent: 'center',
                        }}
                        onClick={() => this.setState({ mostrarCalendario: true })}
                     >
                        <div style={{ height: 24, width: 24, display: 'table-cell', paddingTop: 1 }}>
                           <IconButton
                              style={{ color: '#666', fontSize: 20 }}                              
                              icon={faCalendarAlt}
                              onClick={this.novo}
                           />
                        </div>
                        {this.calendario()}
                     </InputGroup.Text>
                  </InputGroup.Append>
               )}
            </InputGroup>
         </DateInputStyled>
      );
   }

   calendario = () => {
      return (
         <React.Fragment>
            <Modal
               show={this.state.mostrarCalendario}
               onHide={() => {}}
               onKeyDown={(e) => {
                  if (e.keyCode === 27) this.closeCalendar();
               }}
               aria-labelledby='contained-modal-title-vcenter'
               centered
               size='sm'
            >
               <Modal.Body
                  style={{
                     padding: '15px 15px 15px 15px',
                     fontSize: 15,
                     width: 'fit-content',
                  }}
               >
                  {this.state.mostrarCalendario && (
                     <Calendar
                        onChange={this.setDateFromCalendar}
                        value={this.state.date}
                        onClickDay={() => {
                           this.closeCalendar();
                        }}
                        prevLabel={'<'}
                        nextLabel={'>'}
                        prev2Label={null}
                        next2Label={null}
                        showFixedNumberOfWeeks={false}
                        calendarType={'US'}
                     />
                  )}

                  <div style={{ display: 'flex', width: '100%', justifyContent: 'flex-end' }}>
                     <div
                        style={{
                           textAlign: 'right',
                           color: '#999',
                           cursor: 'pointer',
                           marginRight: 10,
                           fontSize: 14,
                           display: 'flex',
                           justifyContent: 'flex-end',
                           width: 140,
                        }}
                        onClick={() => {
                           this.setDateFromCalendar(null);
                           this.closeCalendar();
                        }}
                     >
                        <div
                           style={{
                              display: 'table-cell',
                              paddingLeft: 10,
                              paddingRight: 10,
                           }}
                        >
                           <span>limpar</span>
                        </div>
                     </div>
                     <div
                        style={{
                           color: '#999',
                           textAlign: 'right',
                           marginRight: 10,
                           display: 'flex',
                           justifyContent: 'flex-start',
                           width: '100%',
                        }}
                     >
                        <div
                           style={{
                              cursor: 'pointer',
                              marginRight: 10,
                              display: 'flex',
                           }}
                           onClick={() => {
                              this.closeCalendar();
                           }}
                        >
                           <div
                              style={{
                                 display: 'table-cell',
                                 paddingLeft: 10,
                                 paddingRight: 10,
                              }}
                           >
                              <span>cancelar</span>
                           </div>
                        </div>
                     </div>
                     <div
                        style={{
                           textAlign: 'right',
                           color: '#999',
                           cursor: 'pointer',
                           marginRight: 10,
                           fontSize: 14,
                           display: 'flex',
                           justifyContent: 'flex-end',
                           minWidth: 55,
                        }}
                        onClick={() => {
                           this.setDateFromCalendar(new Date());
                           this.closeCalendar();
                        }}
                     >
                        <div
                           style={{
                              display: 'table-cell',
                              paddingLeft: 10,
                              paddingRight: 10,
                           }}
                        >
                           <span>hoje</span>
                        </div>
                     </div>
                  </div>
               </Modal.Body>
            </Modal>
         </React.Fragment>
      );
   };
}

const DateInputStyled = styled.div`
   .dropdown-toggle {
      box-shadow: none;
   }
`;
